import { useCallback, useMemo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import { LocaleKeysType } from 'shared/locale/en-US'
import { replacePlaceholders } from 'shared/utils/replacePlaceholders'

import { selectLocaleDict } from 'features/locale/selectors'

const getNestedValue = (obj: Record<string, any>, path: string): any =>
  path.split('.').reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj)

export const useAppTranslation = (prefix: Union<LocaleKeysType, string> = '') => {
  const locale = useSelector(selectLocaleDict, shallowEqual)
  const formattedPrefix = useMemo(() => {
    if (prefix) {
      return prefix.endsWith('.') ? prefix : `${prefix}.`
    }

    return prefix
  }, [prefix])

  const getKey = (key: string) => formattedPrefix + key

  const t = useCallback(
    (key: Union<LocaleKeysType, string>, values = {}, defaultReturn?: string) => {
      const returnKey = defaultReturn ?? key
      let translation = getNestedValue(locale, key) ?? returnKey

      return replacePlaceholders(translation, values)
    },
    [locale],
  )

  const tPrefix = useCallback((key: string, options = {}) => t(formattedPrefix + key, options), [t, formattedPrefix])

  return {
    t,
    tPrefix,
    getKey,
    locale,
  }
}
